var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPartnerHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1620_23087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 17.3066H8.78438C7.36875 17.3066 6.20312 18.4816 6.20312 19.8973V23.8879H18.9875V19.8973C18.9875 18.4816 17.8531 17.3066 16.4406 17.3066H16.4375Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6125 15.8529C14.6421 15.8529 16.2875 14.2076 16.2875 12.1779C16.2875 10.1483 14.6421 8.50293 12.6125 8.50293C10.5829 8.50293 8.9375 10.1483 8.9375 12.1779C8.9375 14.2076 10.5829 15.8529 12.6125 15.8529Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13419 6.28125C7.04049 6.28125 7.80563 6.87193 8.06821 7.69061H8.16855V11.1437H-0.12207V8.31561C-0.122064 7.18516 0.808702 6.28125 1.9248 6.28125H6.13419ZM1.12793 9.89374H6.91855V8.94061H6.91544V8.31561C6.91543 7.87864 6.56622 7.53125 6.13419 7.53125H1.9248C1.48467 7.53125 1.12794 7.88982 1.12793 8.31561V9.89374Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42462 3.13126C5.42462 2.35979 4.79921 1.73438 4.02774 1.73438C3.25627 1.73438 2.63086 2.35978 2.63086 3.13126C2.63086 3.90273 3.25627 4.52814 4.02774 4.52814C4.79921 4.52813 5.42462 3.90272 5.42462 3.13126ZM6.67462 3.13126C6.67462 4.59308 5.48956 5.77813 4.02774 5.77814C2.56591 5.77814 1.38086 4.59308 1.38086 3.13126C1.38086 1.66943 2.56591 0.484375 4.02774 0.484375C5.48957 0.484378 6.67462 1.66943 6.67462 3.13126Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 8.31583C23.9062 7.89085 23.6 7.56603 23.2125 7.53143H18.9344C18.5051 7.53143 18.1562 7.87925 18.1562 8.31583V9.89395H23.9062V8.31583ZM25.1562 11.144H16.9062V8.31583C16.9062 7.19615 17.8075 6.28143 18.9344 6.28143H22.5187V6.27832H23.1437C24.2806 6.27832 25.1562 7.20315 25.1562 8.31583V11.144Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4344 3.13126C22.4344 2.35979 21.809 1.73438 21.0375 1.73438C20.266 1.73438 19.6406 2.35978 19.6406 3.13126C19.6406 3.90273 20.266 4.52814 21.0375 4.52814C21.809 4.52813 22.4344 3.90272 22.4344 3.13126ZM23.6844 3.13126C23.6844 4.59308 22.4993 5.77813 21.0375 5.77814C19.5757 5.77814 18.3906 4.59308 18.3906 3.13126C18.3906 1.66943 19.5757 0.484375 21.0375 0.484375C22.4993 0.484378 23.6844 1.66943 23.6844 3.13126Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49687 6.11855H15.9656C16.4125 6.11855 16.775 5.76543 16.775 5.31855C16.775 4.87168 16.4125 4.51855 15.9656 4.51855H9.49687C9.05 4.51855 8.6875 4.87168 8.6875 5.31855C8.6875 5.76543 9.05 6.11855 9.49687 6.11855Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91594 17.3378C7.08157 17.3378 7.24719 17.2878 7.39094 17.1847C7.75344 16.9222 7.83157 16.4159 7.57219 16.0566L4.62219 11.9847C4.35969 11.6222 3.85344 11.5409 3.49407 11.8034C3.13157 12.0659 3.05344 12.5722 3.31282 12.9316L6.26282 17.0034C6.42219 17.2222 6.66907 17.3347 6.91907 17.3347L6.91594 17.3378Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0844 11.8781C20.7094 11.6344 20.2094 11.7469 19.9688 12.1219L17.425 16.0938C17.1813 16.4688 17.2938 16.9688 17.6688 17.2125C17.8031 17.2969 17.9531 17.3375 18.1063 17.3375C18.3719 17.3375 18.6344 17.2063 18.7875 16.9656L21.3313 12.9969C21.5719 12.6219 21.4625 12.1219 21.0875 11.8781H21.0844Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1620_23087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPartnerHub);
export default __webpack_public_path__ + "static/media/ic_partner_hub.ce4ca2e703aff2767d0ba4af757b2ccc.svg";
export { ForwardRef as ReactComponent };